import { Outlet } from 'react-router-dom';
import { TabRow, type SectionTab } from '../components/SectionTabs';
import { PageHeader } from '../components/PageHeader';
import { VersionInfo } from '../components/VersionInfo';
import { useProfile } from '../profile/ProfileProvider';

/**
 * Admin area shell. A segmented pill tab row (the "sliders") for the admin
 * sections + an <Outlet/> for the chosen page — matching the per-tool sub-nav
 * style (replaced the old left side-nav). Wrapped by <RequireAdmin> at the
 * route level so non-admins never reach this layout.
 *
 * This layout provides the page container (max-width + padding); admin pages
 * render bare inside it. The Config tab leads to a second pill row (ConfigLayout).
 */
const ADMIN_TABS: SectionTab[] = [
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/access', label: 'Access' },
  { to: '/admin/data-completeness', label: 'Data completeness' },
  { to: '/admin/countries', label: 'Countries' },
  { to: '/admin/resources', label: 'Resources' },
  { to: '/admin/mail', label: 'Mail' },
  { to: '/admin/email-previews', label: 'Email previews' },
  { to: '/admin/feedback', label: 'Feedback' },
  { to: '/admin/announcements', label: 'Announcements' },
  { to: '/admin/audit', label: 'Audit log' },
  { to: '/admin/usage', label: 'Hub usage' },
  { to: '/admin/remote', label: 'Remote.com' },
];

export function AdminLayout() {
  const { state } = useProfile();
  // Super admins only (the server gates it too): the Command Center feed's switch and keys.
  const isSuper = state.status === 'ready' && (state.user.hubRole === 'super_admin' || state.user.hubRole === 'admin');
  const tabs = isSuper ? [...ADMIN_TABS, { to: '/admin/command-center-feed', label: 'Command Center feed' }] : ADMIN_TABS;
  return (
    <div className="w-full max-w-page px-4 md:px-8 pt-6 pb-10 space-y-6">
      <PageHeader title="Administration">
        <TabRow tabs={tabs} wrap />
      </PageHeader>
      <Outlet />
      <VersionInfo />
    </div>
  );
}
